import { Schema as S } from "effect";

import { AgentBlock, Provenance } from "./common";

export const EventResponse = S.Struct({
	id: S.String,
	datetime: S.String,
	source: S.String,
	circleId: S.String,
	type: S.String,
	version: S.String,
	data: S.Unknown,
	actorId: S.optionalKey(S.NullOr(S.String)),
	agent: S.optionalKey(S.NullOr(AgentBlock)),
	/** Absent from responses older than the provenance feature. */
	provenance: S.optionalKey(Provenance),
});
export type EventResponse = typeof EventResponse.Type;

export const EventActivity = S.Struct({ days: S.Record(S.String, S.Number) });
